module.exports = __webpack_public_path__ + "media/bgm.4474eedb.mp3";